import React, { useState } from "react";
import TableSection from "./TableSection";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { Model, calcularTotalCompra } from "../Model";
import { useListarProductos } from "../../../../services/productosServicios";
import { Button, Stack } from "react-bootstrap";
import SuccessButton from "../../../organisms/SuccessButton";
import { CarritoModal } from "./CarritoModal";
import Confirmacion from "../Confirmacion/Confirmacion";
import { useWizard } from "../../../../hooks/wizard";
import SeleccionMascota from "../SeleccionMascota/SeleccionMascota";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function SeleccionProductos({ model }: { model: Model }) {
  const { data: productos, isLoading, isSuccess, error } = useListarProductos();
  const [mostrarCarrito, setMostrarCarrito] = useState(false);
  const { avanza, avanzar, vuelve, volver } = useWizard();

  const [newModel, setNewModel] = useState(model);

  const onCantidadChange = (
    idProducto: string,
    nombre: string,
    cant: string,
    valor: number
  ) => {
    let detallesPorProducto = new Map(newModel.detallesPorProducto);
    let detallesProd = {
      nombre,
      cantidad: Number.parseInt(cant),
      valor,
    };
    detallesPorProducto.set(idProducto, detallesProd);

    setNewModel((prev) => ({
      ...prev,
      detallesPorProducto: detallesPorProducto,
      total: calcularTotalCompra(Array.from(detallesPorProducto.values())),
    }));
  };

  const onCarritoClick = () => {
    setMostrarCarrito(true);
  };

  const onCerrarCarrito = () => {
    setMostrarCarrito(false);
  };

  const puedeAvanzar = newModel.detallesPorProducto.size > 0;

  if (error) {
    return <ServerErrorModal />;
  }

  if (avanza) {
    return <Confirmacion model={newModel} />;
  }

  if (vuelve) {
    return <SeleccionMascota model={newModel} />;
  }

  return (
    <>
      <CarritoModal
        show={mostrarCarrito}
        onClose={onCerrarCarrito}
        detallesPorProducto={newModel.detallesPorProducto}
        total={newModel.total}
      />
      <Stack className="p-2">
        <TableSection
          title={"Seleccionar productos"}
          items={productos || []}
          onProductoCantidadChange={onCantidadChange}
          detallesPorProducto={newModel.detallesPorProducto}
          isLoading={isLoading}
          isSuccess={isSuccess}
          onCarritoClick={onCarritoClick}
        />
        <section className="d-flex justify-content-between">
          <Button onClick={volver}>
            <ArrowBackIcon sx={{ fontSize: 20 }} />
            Volver
          </Button>
          <SuccessButton
            style={{ width: "fit-content" }}
            disabled={!puedeAvanzar}
            onClick={avanzar}
            variant="success"
          >
            Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
          </SuccessButton>
        </section>
      </Stack>
    </>
  );
}

export default SeleccionProductos;
